export default {

    /** 郵便番号Csvインポート **/
    // 0:waiting 1:loading 2:success 3:failed
    importPostalCsvStatus: 0,

    /** システムメール送信情報取得**/
    sysMailInfo: {},
    // 0:waiting 1:loading 2:success 3:failed
    sysMailInfoLoadStatus: 0,

    /** システムメールグループ名・ステータス修正　**/
    // 0:waiting 1:loading 2:success 3:failed
    mailGroupEditSaveStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    mailGroupEditDelStatus: 0,


    /** システムメール送信グループ **/
    mailGroupMember: {},
    mailGroupMemberSelected: [],
    // 0:waiting 1:loading 2:success 3:failed
    mailGroupMemberLoadStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    changeMailGroupStatus: 0,

    /** システムメールテンプレート保存　**/
    
    mailTempSave: {},
    // 0:waiting 1:loading 2:success 3:failed
    mailTempSaveStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    mailTempDelStatus: 0,
    // 0:waiting 1:loading 2:success 3:failed
    sysMailSendStatus: 0,
    // 送信人数
    sysMailSendCnt: 0,




}
